import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import wenhao from '@/assets/images/wenhao.png'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import './index.scss'
import {Button, Descriptions, message, Modal, Tooltip} from 'antd'
import {getgaishuList,saveGaishu} from "../../../../servers/province";
import {withRouter} from "react-router-dom";
import CInput from "../../../../components/CForm/CInput";
import {getStorage} from "../../../../utils";
import store from "../../../../redux";

@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.setValueData = this.setValueData.bind(this)
    this.addData = this.addData.bind(this)
  }

  state = {
    loading:false,
    memo:'',
    title:'',
    museumid:'',
    museum:false,
    type:''
  };

  addData(){
    this.setState({
      loading: true
    });
    const params = {
      type: 'res',
      memo:encodeURIComponent(this.state.memo)
    }
    saveGaishu(params).then(res=>{
      if(res.statecode === 0) {
        message.success('保存成功');
      } else {
        message.error(res.statemessage);
      }
      this.getListData()
      this.setState({
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  setValueData(value){
    this.setState({
      memo:value
    })
  }
  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      museumid:result.museumid ? result.museumid:this.state.museumid,
      annual:result.annual,
      type: 'res'
    }
    getgaishuList(params).then(res=>{
      if (res.records.length>0){
        this.setState({
          loading: false,
          memo:decodeURIComponent(res.records[0].memo),
          title:res.records[0].tips,
        });
      } else {
        this.setState({
          loading: false
        });
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentDidMount(){
    const type = getStorage('userList').clerklevel
    this.setState({
      type:type
    })
    if (type != 8 && type != 9) {
      const museumid = store.getState().libraryid
      this.setState({
        museumid:museumid,
        meseum:true
      },()=>{
        this.getListData();
      })
    } else {
      this.getListData()
    }
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const museumid = store.getState().libraryid
        this.setState({
          museumid:museumid,
          meseum:true
        },()=>{
          this.getListData();
        })
      }
    })
  }
  render(){
    return (
        <div className={this.state.type != 8 && this.state.type != 9 ? 'user-manage-list list-disabled': 'user-manage-list'}>
          博物馆资源概述：
          <Tooltip placement="right" title={this.state.title}>
            <img src={wenhao} alt="" style={{width:'17px',verticalAlign:'middle',marginTop:'-3px',cursor:'pointer'}}/>
          </Tooltip>
          <CInput
              value={this.state.memo}
              onChange={(value)=>{this.setValueData(value)}}
              type='textarea'
              style={{marginTop:'20px'}}
              disabled={this.state.type != 8 && this.state.type != 9}
              expand={{
                    autosize: {minRows: 30, maxRows: 50}
                 }}
          />
          {this.state.type != 8 && this.state.type != 9 ? '':<Button type="primary" onClick={()=>{this.addData()}} style={{marginTop:'20px'}}>保存</Button>}
 </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
